export const HERO_STAGE_WIDTH = 640
